import React, { useCallback } from 'react'
import { Select, Text } from '@mantine/core'

import { useTranscriptOrderChange } from './useTranscriptOrderChange'

import { AttendeeCard } from '@/components/Event/NewScript/components/common/AttendeeCard/AttendeeCard'
import { TURNAROUND_TIME_OPTIONS, TurnaroundHours } from '@/constants'
import { Event, ScriptAttendee } from '@/types'

type Props = {
  onChange: (attendee: ScriptAttendee) => void
  attendee: ScriptAttendee
  event: Event
  namePrefix: string
  allAttendees: ScriptAttendee[]
}

export const AttendeeTranscriptOrderCard: React.FC<Props> = ({
  attendee,
  onChange,
  event,
  namePrefix,
  allAttendees,
}) => {
  const onTurnaroundHoursChange = useTranscriptOrderChange(
    useCallback(
      (transcriptOrder: string | null) =>
        onChange({ ...attendee, transcript_order: transcriptOrder }),
      [attendee, onChange],
    ),
  )

  const onAttendeeChange = useCallback(
    (attendee: ScriptAttendee) => {
      onChange(attendee)
    },
    [onChange],
  )

  return (
    <AttendeeCard
      key={attendee.attendee_id}
      event={event}
      attendee={attendee}
      onSubmitClick={onAttendeeChange}
      emailEmptySlot={
        <Text color="red" italic>
          missing email address
        </Text>
      }
      namePrefix={namePrefix}
      allAttendees={allAttendees}
    >
      <Select
        value={
          attendee.transcript_order ?? TurnaroundHours.ROUGH_DRAFT.toString()
        }
        placeholder="Certified not ordered"
        data={TURNAROUND_TIME_OPTIONS}
        onChange={onTurnaroundHoursChange}
      />
    </AttendeeCard>
  )
}
